import React from 'react'

import { B2 } from '@zet/design-system/typography'
import { i18n } from '@zet/localization'

import CommissionType from './commissionType'

interface Props {
  commissionType: string
  brandCommission: string | number
}

const PayoutTextFallBackHi: React.FC<Props> = (props) => {
  const { commissionType, brandCommission } = props
  return (
    <B2 className="text-grays-50 mt-2">
      {i18n.t('myLeads.DaysExpired')}
      <CommissionType
        commissionType={commissionType}
        brandCommission={brandCommission}
      />
    </B2>
  )
}

const PayoutTextFallBackEn: React.FC<Props> = (props) => {
  const { commissionType, brandCommission } = props

  return (
    <B2 className="text-grays-50 mt-2">
      {i18n.t('myLeads.DaysExpired')}
      <CommissionType
        commissionType={commissionType}
        brandCommission={brandCommission}
      />
    </B2>
  )
}

const PayoutTextFallBack: React.FC<Props> = (props) => {
  if (i18n.locale === 'en') {
    return <PayoutTextFallBackEn {...props} />
  } else {
    return <PayoutTextFallBackHi {...props} />
  }
}

export default PayoutTextFallBack
